import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
interface ButtonProps extends HTMLMotionProps<'button'> {
  variant?: 'primary' | 'outline' | 'ghost' | 'luxury';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  size = 'md',
  className = '',
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center transition-all duration-300 focus:outline-none disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-brand-dark text-brand-cream hover:bg-brand-dark/90 font-medium',
    outline: 'border border-brand-dark/20 text-brand-dark hover:border-brand-dark hover:bg-brand-dark hover:text-brand-cream font-medium',
    ghost: 'text-brand-dark hover:bg-brand-stone/30 font-medium',
    luxury: 'border border-brand-dark/30 text-brand-dark hover:bg-brand-dark hover:text-brand-cream tracking-[0.15em] uppercase text-xs font-semibold'
  };
  const sizes = {
    sm: 'h-10 px-5 text-sm',
    md: 'h-12 px-8 text-base',
    lg: 'h-14 px-10 text-lg'
  };
  return <motion.button whileTap={{
    scale: 0.99
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-319" data-mp="eqploxme9w5d">
      {children}
    </motion.button>;
}